import * as firebase from 'firebase/app'
import 'firebase/firestore';
import 'firebase/auth'
import 'firebase/storage'

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDMwvRUz7lbq6bsEMA1wX5wLP8i0CjWTuI",
    authDomain: "finans-app-f9929.firebaseapp.com",
    databaseURL: "https://finans-app-f9929.firebaseio.com",
    projectId: "finans-app-f9929",
    storageBucket: "finans-app-f9929.appspot.com",
    messagingSenderId: "264423528465",
    appId: "1:264423528465:web:3cef231e4d075d5fb339b0",
    measurementId: "G-W1KRJXX9XP"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig)
export const auth = app.auth();
export const firestore = app.firestore();
export const storage = app.storage();

export const timestamp = firebase.firestore.FieldValue.serverTimestamp;